module.exports = __webpack_public_path__ + "static/media/content-created-icon.cbc6b71a.svg";